import { render, staticRenderFns } from "./XkMaxDialog.vue?vue&type=template&id=6cb26228&scoped=true&"
import script from "./XkMaxDialog.vue?vue&type=script&lang=js&"
export * from "./XkMaxDialog.vue?vue&type=script&lang=js&"
import style0 from "./XkMaxDialog.vue?vue&type=style&index=0&id=6cb26228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb26228",
  null
  
)

export default component.exports